import React from "react";
import NumberFormat from "react-number-format";
import classNames from "classnames";
import FieldLabel from "../base/FieldLabel";


const PhoneField  = React.forwardRef( (props, ref) =>{

  const inputClass = classNames("form-input", {
    "form-input--error": !props.valid
  });

  const onValueChange = (val) => {
    const { onChange } = props;
    const e = {
      target: {
        name: props.name,
        formattedValue: val.formattedValue,
        value: val.value
      }
    };
    onChange(e);
  };
  const onBlurField = (val) => {
    const {onBlur} = props;
    const e = {
      target: {
        name: props.name,
        formattedValue: val.formattedValue,
        value: val.value
      }
    };
    onBlur(e);
  };

  return <div className={`${inputClass} ${props.className || ""}`}>
    <FieldLabel {...props} />
    <NumberFormat value={props.value} className="form-input__field"
      getInputRef={ref}
      type={"tel"}
      name={"phone"}
      readOnly={props.readOnly}
      onValueChange={onValueChange}
      placeholder={"___-___-____"}
      format="###-###-####"
      mask="_"
      onBlur={onBlurField}
      autoFocus={!!props.autoFocus} // eslint-disable-line
      data-automation-id={props.dataAutomationId}/>
    <React.Fragment>{props.children}</React.Fragment>
  </div>;
});

PhoneField.displayName = "PhoneField";

export default PhoneField;
